import { BorderedBox } from "pages/LessonRecord/components";
import {
	imageModalReducerActions,
	useImageModalContext,
} from "contexts/imageModal";
import { ProtectedImg } from "components";
import { imageTypes } from "pages/LessonRecord/constants";

export const InClassPhotos = ({ lessonFiles }) => {
	const { dispatch: imageModalDispatch } = useImageModalContext();
	const inClassPhotos = lessonFiles?.filter(
		(lessonFile) => lessonFile.type === imageTypes.IN_CLASS_IMAGES
	);

	return (
		<BorderedBox className="align-items-center">
			{inClassPhotos?.length ? (
				inClassPhotos?.map((lessonFile, index) => (
					<div
						className="col-6 col-sm-4 col-md-3 col-lg-2"
						key={lessonFile.id}
					>
						<ProtectedImg
							src={lessonFile.filepath || lessonFile.data}
							className="img-fluid rounded"
							onClick={() =>
								imageModalDispatch({
									type: imageModalReducerActions.SHOW,
									payload: lessonFile.filepath,
								})
							}
						/>
					</div>
				))
			) : (
				<div className="ml-2 d-flex align-items-center">
					No in class photos
				</div>
			)}
		</BorderedBox>
	);
};
